import FaqAccordion from './FaqAccordion';

const CabaIntroSection = () => {
  return (
    <section style={styles.wrapper}>
      <div style={styles.overlay}>
        <div style={styles.content}>
          {/* ふわっと登場アニメーション */}
          <h2 style={styles.heading} className="fade-in">キャバクラとは？</h2>
          <p style={styles.text}>
            キャバクラとは、お客様にお酒を提供しながら、会話や時間を楽しんでいただく接客業のひとつです。
            高級感のある店内で、丁寧な接客や聞き上手なトークが求められますが、
            <span style={styles.strong}>難しい技術や経験は一切不要</span>です。
          </p>
          <p style={styles.text}>
            お店によっては教育マニュアルや研修制度が整っており、
            <span style={styles.strong}>言葉遣いや座り方など、基礎から優しく教えてくれる</span>環境が用意されています。
            お酒が飲めなくてもOK、明るく挨拶ができれば大丈夫。
            <span style={styles.strong}>未経験からスタートして活躍している方が多数</span>いる業界です。
          </p>

          <h2 style={styles.heading} className="fade-in">当サイトからの応募のメリット・面接の流れ</h2>
          <p style={styles.text}>
            応募はとっても簡単！
            <span style={styles.strong}>応募ボタンからLINEを「相談したい！」と送るだけ</span>で、
            すぐに専属スタッフが対応します。
          </p>
          <p style={styles.text}>
            「最寄り駅」「希望エリア」「出勤希望日数」「お酒が飲めるか」「学校や仕事との両立」などの条件をヒアリングし、
            <span style={styles.strong}>あなたにピッタリなお店を複数提案</span>。
          </p>
          <p style={styles.text}>
            面接時は服装のアドバイスや、同行・交通案内なども行っており、
            <span style={styles.strong}>不安なことはLINEでいつでも相談可能</span>。
          </p>
          <p style={styles.text}>
            最短で当日体験入店もOK！
            <span style={styles.strong}>無理な勧誘ゼロで、納得してから決められる</span>ので安心です。
          </p>

          <h2 style={styles.heading} className="fade-in">みんなが気になる質問(タップで回答を確認)</h2>
          <FaqAccordion />
        </div>
      </div>

      {/* アニメーションCSS */}
      <style>
        {`
          .fade-in {
            opacity: 0;
            transform: translateY(20px);
            animation: fadeInUp 1s ease-out forwards;
          }

          @keyframes fadeInUp {
            0% {
              opacity: 0;
              transform: translateY(20px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </section>
  );
};

const styles = {
  wrapper: {
    position: 'relative',
    backgroundImage: `url("/images/キャバ背景用.png")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'repeat-y',
    padding: '60px 16px',
  },
  overlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    padding: '28px 18px',
    borderRadius: '16px',
    maxWidth: '760px',
    margin: '0 auto',
    boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
  },
  content: {
    fontFamily: '"M PLUS Rounded 1c", "Kosugi Maru", sans-serif',
    textAlign: 'left',
    color: '#333',
    boxSizing: 'border-box',
  },
  heading: {
    fontSize: '5vw',
    marginBottom: '16px',
    padding: '10px 5%',
    backgroundImage: 'linear-gradient(135deg, #ffd1dc, #ffe4e1)',
    backgroundSize: '100% 100%',
    backgroundPosition: 'center',
    color: '#e91e63',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    textAlign: 'center',
    width: '100%',
    boxSizing: 'border-box',
    wordBreak: 'break-word',     
    whiteSpace: 'normal',        
    lineHeight: '1.4',           
  },
  text: {
    fontSize: '15px',
    lineHeight: '1.8',
    marginBottom: '18px',
    wordWrap: 'break-word',
    textAlign: 'left',
    maxWidth: '100%',
  },
  strong: {
    fontWeight: 'bold',
    color: '#c2185b',
    backgroundColor: '#fff',
    padding: '1px 4px',
    borderRadius: '4px',
  },
};

export default CabaIntroSection;
